function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  "data-name": "Group 4141",
  fill: "none",
  stroke: "#1739e6",
  strokeLinecap: "round",
  strokeWidth: 2
}, React.createElement("path", {
  "data-name": "Line 1",
  d: "M15.556 1.415L1.414 15.557"
}), React.createElement("path", {
  "data-name": "Path 231",
  d: "M15.556 15.557L1.414 1.415"
}));

var SvgClose = function SvgClose(props) {
  return React.createElement("svg", _extends({
    width: 16.971,
    height: 16.971
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNi45NzEiIGhlaWdodD0iMTYuOTcxIiB2aWV3Qm94PSIwIDAgMTYuOTcxIDE2Ljk3MSI+CiAgPGcgaWQ9Ikdyb3VwXzQxNDEiIGRhdGEtbmFtZT0iR3JvdXAgNDE0MSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTI1My44NTIgMjE1LjY2OCkgcm90YXRlKC00NSkiPgogICAgPGxpbmUgaWQ9IkxpbmVfMSIgZGF0YS1uYW1lPSJMaW5lIDEiIHgxPSIyMCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzIyIDM5KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMTczOWU2IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS13aWR0aD0iMiIvPgogICAgPHBhdGggaWQ9IlBhdGhfMjMxIiBkYXRhLW5hbWU9IlBhdGggMjMxIiBkPSJNMjAsMEgwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzMzIgMjkpIHJvdGF0ZSg5MCkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzE3MzllNiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiLz4KICA8L2c+Cjwvc3ZnPgo=";
export { SvgClose as ReactComponent };